import React from 'react';
import cn from 'classnames';

export default function Rows({ className = '', children = null }) {
  return <div className={cn('CustomTable__Rows', className)}>{children}</div>;
}
